import React from "react";
import { Form } from "react-bootstrap";
import { FormikProps } from "formik";
import { FormValues } from "../types";

interface SimulatorSelectFieldProps {
  formik: FormikProps<FormValues>;
  name: keyof FormValues & string;
  label: React.ReactNode;
  disabled?: boolean;
  controlId?: string;
  labelStyle?: React.CSSProperties;
  onChange?: (e: React.ChangeEvent<any>) => void;
  /** Opções do select (elementos <option>). */
  children: React.ReactNode;
  /** Exibe o erro do formik em um span vermelho abaixo do select. */
  showError?: boolean;
}

const groupStyle: React.CSSProperties = {
  width: "100%",
  maxWidth: "375px",
  height: "80px",
};

export const SimulatorSelectField = ({
  formik,
  name,
  label,
  disabled,
  controlId,
  labelStyle,
  onChange,
  children,
  showError,
}: SimulatorSelectFieldProps) => (
  <Form.Group controlId={controlId ?? name} style={groupStyle}>
    <Form.Label className="simulacao-form-title" style={labelStyle}>
      {label}
    </Form.Label>
    <Form.Control
      as="select"
      name={name}
      disabled={disabled}
      onChange={onChange ?? formik.handleChange}
      onBlur={formik.handleBlur}
      value={formik.values[name] as string | number}
    >
      {children}
    </Form.Control>
    {showError && (
      <span style={{ color: "red" }}>{formik.errors[name] as string}</span>
    )}
  </Form.Group>
);
